export const isArrayMinLength = (length: number) => (value: unknown) => {
  if (Array.isArray(value)) {
    return value.length < length ? 'Error' : undefined;
  }
};
